import { SubZoneAction, SubZoneState } from 'store/data/subZone';
import { domainUtility } from 'utility';

const initialState: SubZoneState = { allIds: [], byId: {} };

const subZoneReducer = (
  state: SubZoneState = initialState,
  action: SubZoneAction,
): SubZoneState => {
  switch (action.type) {
    case 'data/subZone/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/subZone/SET':
      return domainUtility.set(state, action.payload);
    case 'data/subZone/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/subZone/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/subZone/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default subZoneReducer;
